import './services.location';
import './services.recaptcha';
import { RECAPTCHA_VERIFICATION_FAILED } from '../../constants/recaptchable';

const RECAPTCHA_RESPONSE_ELEMENT_ID = 'g-recaptcha-response';

const getRecaptchaResponse = function () {
  return document.getElementById(RECAPTCHA_RESPONSE_ELEMENT_ID)?.value;
};

const clearRecaptchaResponse = function () {
  const recaptchaResponseElement = document.getElementById(
    RECAPTCHA_RESPONSE_ELEMENT_ID,
  );
  if (recaptchaResponseElement) {
    recaptchaResponseElement.value = '';
  }
};

const setRecaptchaResponse = function (token) {
  const recaptchaResponseElement = document.getElementById(
    RECAPTCHA_RESPONSE_ELEMENT_ID,
  );
  if (recaptchaResponseElement) {
    recaptchaResponseElement.value = token;
  }
};

const buildFormData = function (formId, element) {
  const formDataArray = $('#form-' + formId).serializeArray();
  let addressElIndex = 0;
  let elementName = null;

  return _.reduce(
    formDataArray,
    function (acc, el) {
      let nameArr;
      let fieldName;
      if (el.name.includes('[]')) {
        nameArr = el.name.split('[]');
        fieldName = nameArr[0];
        if (acc[fieldName] && $.isArray(acc[fieldName])) {
          acc[fieldName].push(el.value);
        } else {
          acc[fieldName] = [el.value];
        }
        return acc;
      }
      // construct address field key/value map for address type data
      if (el.value && el.name.includes('{}')) {
        // when element changed, the index should reset from 0
        if (elementName !== el.name) {
          elementName = el.name;
          addressElIndex = 0;
        }
        nameArr = el.name.split('{}');
        fieldName = nameArr[0];
        const addressEls = element.find('[name="' + el.name + '"]');
        const addressEl = addressEls[addressElIndex];
        const $el = $(addressEl);
        const addressType = $el.attr('address-type');
        if (addressType) {
          if (!acc[fieldName]) acc[fieldName] = {};
          acc[fieldName][addressType] = el.value;
        }
        addressElIndex++;
        return acc;
      }
      if (el.value && !el.value.match(/undefined/)) {
        acc[el.name] = el.value;
      }
      return acc;
    },
    {},
  );
};

const getRecaptchaToken = function (mainConfig, recaptcha, RecaptchaService) {
  if (!mainConfig.isRecaptchaEnabled) {
    return Promise.resolve();
  }

  if (recaptcha.isUseCheckbox) {
    const token =
      recaptcha.checkboxToken ||
      RecaptchaService.getResponse(recaptcha.checkboxWidgetId) ||
      getRecaptchaResponse();
    setRecaptchaResponse(token);
    return Promise.resolve(token);
  }

  return RecaptchaService.executeWithPromise();
};

const getSubmitData = function (mainConfig, recaptcha, formData) {
  const data = {
    formData: formData,
  };

  if (mainConfig.isRecaptchaEnabled) {
    data.recaptchable = true;
  }

  if (recaptcha.isUseCheckbox) {
    data.is_use_checkbox = true;
  }

  return data;
};

const renderRecaptchaCheckboxWidget = function (context) {
  context.RecaptchaService.renderRecaptchaWidget({
    element: context.recaptchaCheckboxElement,
    callback: function (token) {
      handleRecaptchaCheckboxCallback(context, token);
    },
    expiredCallback: function () {
      handleRecaptchaCheckboxExpired(context);
    },
    onRendered: function (widgetId) {
      context.recaptcha.checkboxWidgetId = widgetId;
    },
    isInvisible: false,
  });
};

const renderRecaptchaCheckbox = function (context) {
  const { recaptcha } = context;
  recaptcha.isUseCheckbox = true;
  recaptcha.checkboxToken = null;
  clearRecaptchaResponse();
  context.recaptchaCheckboxWrapper.show();

  if (recaptcha.isCheckboxRendered || !context.recaptchaCheckboxElement) {
    return;
  }

  recaptcha.isCheckboxRendered = true;
  context.RecaptchaService.waitRecaptchaLoaded(function () {
    renderRecaptchaCheckboxWidget(context);
  });
};

const submitAfterRecaptchaCallback = function (context) {
  context.$timeout(function () {
    if (
      !context.form.$valid ||
      context.form.$invalid ||
      context.form.submitting
    ) {
      return;
    }

    submitForm(context);
  }, 0);
};

const handleRecaptchaCheckboxCallback = function (context, token) {
  context.recaptcha.checkboxToken = token;
  setRecaptchaResponse(token);
  submitAfterRecaptchaCallback(context);
};

const handleRecaptchaCheckboxExpired = function (context) {
  context.recaptcha.checkboxToken = null;
  clearRecaptchaResponse();
};

const shouldFallbackToRecaptchaCheckbox = function (
  mainConfig,
  recaptcha,
  res,
) {
  return (
    mainConfig?.isRecaptchaEnterprise &&
    !recaptcha.isUseCheckbox &&
    res?.data?.error_code === RECAPTCHA_VERIFICATION_FAILED
  );
};

const showError = function (context, res) {
  const errorMessage = res?.data?.error || 'reCAPTCHA verification failed';
  if (context.alert) {
    context.alert.fadeOut(function () {
      context.alert.text(errorMessage).fadeIn();
    });
  } else {
    context.alert = $(`<div class="alert alert-danger">${errorMessage}</div>`);
    context.element.prepend(context.alert);
  }

  $('html, body').animate({ scrollTop: 0 }, 600);
};

const resetSubmittedForm = function ({ form, $timeout }) {
  form.$$element[0] && form.$$element[0].reset();
  // reset form to unsubmmited state for resubmit
  $timeout(function () {
    form.$setPristine();
    form.$setUntouched();
    form.$submitted = false;
  }, 10);
};

const showFormSubmissionSuccess = function (element) {
  element
    .find('.FormBuilder-container > :not(.FormBuilder-submit-success)')
    .remove();
  element.find('.FormBuilder-submit-success').addClass('active');
};

const handleSubmitSuccess = function (context) {
  const { $rootScope, element, scope } = context;
  $rootScope.$broadcast('form.response.submit', scope.formId);

  if (scope.onFormSubmission === 'clear_form') {
    resetSubmittedForm(context);
    return;
  }

  showFormSubmissionSuccess(element);
};

const handleSubmitError = function (context, res) {
  const { mainConfig, recaptcha } = context;
  if (shouldFallbackToRecaptchaCheckbox(mainConfig, recaptcha, res)) {
    renderRecaptchaCheckbox(context);
    return;
  }

  showError(context, res);
};

const handleSubmitFinally = function ({ form, ladda }) {
  form.submitting = false;
  if (ladda) {
    ladda.stop();
  }
};

const submitFormData = function (context, formData) {
  const { $http, mainConfig, recaptcha, scope } = context;
  return $http({
    method: 'POST',
    url: window.location.origin + scope.requestUrl,
    data: getSubmitData(mainConfig, recaptcha, formData),
  });
};

const submitForm = function (context) {
  const { form, ladda, mainConfig, recaptcha, RecaptchaService } = context;
  const formData = context.getFormData();
  // comment out for now until product confirm empty form submittion with locale texts
  // if (Object.keys(formData).length === 0) {
  //   return;
  // }

  if (
    recaptcha.isUseCheckbox &&
    !(recaptcha.checkboxToken || getRecaptchaResponse())
  ) {
    return;
  }

  if (ladda) {
    ladda.start();
  }

  form.submitting = true;

  return getRecaptchaToken(mainConfig, recaptcha, RecaptchaService)
    .then(function () {
      return submitFormData(context, formData);
    })
    .then(function () {
      handleSubmitSuccess(context);
    })
    .catch(function (res) {
      handleSubmitError(context, res);
    })
    .finally(function () {
      handleSubmitFinally(context);
    });
};

const handleFormSubmit = function (context, e) {
  const { form } = context;
  e.preventDefault();

  if (!form.$valid || form.$invalid || form.submitting) {
    return;
  }

  submitForm(context);
};

app.directive('slForm', [
  '$http',
  'locationService',
  '$rootScope',
  '$timeout',
  'mainConfig',
  'RecaptchaService',
  function (
    $http,
    locationService,
    $rootScope,
    $timeout,
    mainConfig,
    RecaptchaService,
  ) {
    return {
      restrict: 'C',
      require: 'form',
      scope: {
        requestUrl: '@',
        formId: '@',
        onFormSubmission: '@',
      },
      compile: function (element) {
        var formData = {};
        element[0].noValidate = true;

        element
          .find('.sl-validatable')
          .filter(
            '[item-type=short_text], [item-type=long_text], [item-type=dropdown], [item-type=checkbox], [item-type=radio], [item-type=address]',
          )
          .attr('control-group', '')
          .attr('watch-field-validity', '')
          .attr('field-name', function () {
            return this.getAttribute('label');
          });

        element
          .find('input[type="text"], input[type="radio"], select, textarea')
          .each(function () {
            var $el = $(this);
            var id = $el.attr('item-id');
            var addressType = $el.attr('address-type');
            $el
              .attr('name', function () {
                return addressType ? id + '{}' : id;
              })
              .attr('ng-model', function () {
                this.dataset.modelKey = id;
                var modelKey = addressType ? id + '-' + addressType : id;
                return 'formBuilderForm.formData["' + modelKey + '"]';
              });
          });

        element.find('input[type="checkbox"]').each(function (i) {
          var $el = $(this);
          var value = this.value;
          var id = $el.attr('item-id');

          $el
            .attr('name', function () {
              return id + '[]';
            })
            .attr('ng-model', function () {
              var modelKey = this.type !== 'checkbox' ? id : id + '-' + i;
              this.dataset.modelKey = modelKey;
              return 'formBuilderForm.formData["' + modelKey + '"]';
            });

          if (!formData[id]) {
            formData[id] = [];
          }

          var values = formData[id];

          Object.defineProperty(formData, this.dataset.modelKey, {
            get: function () {
              return values.indexOf(value) !== -1;
            },
            set: function (check) {
              if (check) {
                values.push(value);
              } else {
                values.splice(values.indexOf(value), 1);
              }
            },
          });

          if (this.required) {
            this.removeAttribute('required');
            this.setAttribute(
              'ng-required',
              'formBuilderForm.checkboxRequired("' + id + '")',
            );
          }
        });

        return function postLink(scope, element, attrs, form) {
          let ladda;
          const submitBtn = _.find(element.find('button'), function (button) {
            return (button.type = 'submit');
          });
          const recaptcha = {
            isUseCheckbox: false,
            isCheckboxRendered: false,
            checkboxToken: null,
          };
          const recaptchaCheckboxWrapper = element.find(
            '.FormBuilder-recaptcha-checkbox-wrapper',
          );
          const recaptchaCheckboxElement = element.find(
            '.FormBuilder-recaptcha-checkbox',
          )[0];
          const queryParams = locationService.getQueryParams();
          if (queryParams['is_preview']) {
            submitBtn.remove();
          } else if (submitBtn) {
            submitBtn.classList.add('ladda-button');
            submitBtn.setAttribute('data-style', 'slide-down');
            ladda = Ladda.create(submitBtn);
          }

          const submitContext = {
            $http,
            $rootScope,
            $timeout,
            RecaptchaService,
            alert: null,
            element,
            form,
            getFormData: function () {
              return buildFormData(scope.formId, element);
            },
            ladda,
            mainConfig,
            recaptcha,
            recaptchaCheckboxElement,
            recaptchaCheckboxWrapper,
            scope,
          };

          form.checkboxRequired = function (id) {
            return !submitContext.getFormData()[id];
          };

          element.on('submit', function (e) {
            handleFormSubmit(submitContext, e);
          });
        };
      },
    };
  },
]);
